<template>
  <div
    v-if="provider && providerUid"
    :class="$style.root"
  >
    <Player controls>
      <Vimeo
        v-if="provider === 'vimeo'"
        :videoId="providerUid"
      />
      <Youtube
        v-else-if="provider === 'youtube'"
        :videoId="providerUid"
      />
    </Player>

    <core-text-component
      v-if="richText"
      :string="richText"
      :class="$style.richText"
    />
  </div>
</template>

<script lang="ts" setup>
import '@vime/core/themes/default.css'
import { Player, Vimeo, Youtube } from '@vime/vue-next';

const props = defineProps({
  provider: {
    type: String,
    required: true,
  },
  providerUid: {
    type: String,
    required: true,
  },
  richText: {
    type: String,
    required: false
  },
})
</script>

<style module>
.root {
  --compensation: 1px;
  margin: calc(var(--compensation) * -1);
  position: relative;
}

.root:after {
  content: '';
  position: absolute;
  top: var(--compensation);
  right: var(--compensation);
  bottom: var(--compensation);
  left: var(--compensation);
  outline: var(--compensation) solid var(--color--background);
  z-index: 1;

  pointer-events: none;
}

.richText {
  composes: font-size-small caption from global;
  margin-top: var(--unit--vertical);
}
</style>
